import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/header";
import Hero from "./components/hero";
import ContinentsSection from "./components/continents-section";
import BeyondRecruitment from "./components/beyond-recruitment";
import Testimonials from "./components/testimonials";
import LatestInsights from "./components/latest-insights";
import HomeBlogs from "./components/home-blogs";
import BrandsSection from "./components/brands-section";
import Footer from "./components/footer";
import ContactUs from "./components/contact-us";
import AboutUs from "./components/about-us";
import BlogDetail from "./components/blog-detail";
import Blogs from "./components/blogs";
import BlogCreate from "./components/blog-create";
import BlogSingle from "./components/blog-single";
import ScrollManager from "./components/scroll-manager";
import Careers from "./components/careers";
import PrivacyPolicy from "./components/privacy-policy";
import CookiePolicy from "./components/cookie-policy";
import TermsAndConditions from "./components/terms-and-conditions";

function HomePage() {
  return (
    <main>
      <Header />
      <Hero />
      <BeyondRecruitment />
      <Testimonials />
      <LatestInsights />
      <HomeBlogs />
      <ContinentsSection />
      <BrandsSection />
      <Footer />
    </main>
  );
}

function ContactPage() {
  return (
    <main>
      <Header />
      <ContactUs />
      <Footer />
    </main>
  );
}

function AboutPage() {
  return (
    <main>
      <Header />
      <AboutUs />
      <Footer />
    </main>
  );
}

function CareersPage() {
  return (
    <main>
      <Header />
      <Careers />
      <Footer />
    </main>
  );
}

function PrivacyPolicyPage() {
  return (
    <main>
      <Header />
      <PrivacyPolicy />
      <Footer />
    </main>
  );
}

function CookiePolicyPage() {
  return (
    <main>
      <Header />
      <CookiePolicy />
      <Footer />
    </main>
  );
}

function TermsAndConditionsPage() {
  return (
    <main>
      <Header />
      <TermsAndConditions />
      <Footer />
    </main>
  );
}

function App() {
  return (
    <Router>
      <ScrollManager />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about-us" element={<AboutPage />} />
        <Route path="/contact-us" element={<ContactPage />} />
        <Route path="/careers" element={<CareersPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/cookie-policy" element={<CookiePolicyPage />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditionsPage />} />
        <Route path="/blog/:id" element={<BlogDetail />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/blogs/create" element={<BlogCreate />} />
        <Route path="/blogs/:slug" element={<BlogSingle />} />
      </Routes>
    </Router>
  );
}

export default App;

